module.exports = __webpack_public_path__ + "img/taylorBellCastingHall201027-086.bdc03e5c.jpg";